import { render, staticRenderFns } from "./pcHeader.vue?vue&type=template&id=652802be&scoped=true&"
import script from "./pcHeader.vue?vue&type=script&lang=js&"
export * from "./pcHeader.vue?vue&type=script&lang=js&"
import style0 from "./pcHeader.vue?vue&type=style&index=0&id=652802be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652802be",
  null
  
)

export default component.exports